import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deletePipelineQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

const useDeletePipeline = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePipelineQuery,
    onSuccess: () => {
      toast.success('Pipeline deleted successfully');
      queryClient.invalidateQueries({ queryKey: queryKeys.getList() });
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? error?.message ?? 'Failed to delete pipeline';
      toast.error(message);
    },
  });
};

export default useDeletePipeline;
